
import { Box, Typography, useTheme } from '@mui/material';

export const OpScore = ({ 
  score, 
  size = 50, 
  strokeWidth = 8, 
  progressColor = 'primary.main',
  backgroundColor = '#e0e0e0',
  textColor = 'text.primary',
  fontSize = 10,
  showPercentage = true
}) => {
  const theme = useTheme();
  const radius = (size - strokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;
  const progress = (score / 100) * circumference;
  
  // Get the actual color from theme if it's a theme path
  const getColor = (color) => {
    if (color.includes('.')) {
      const colorPath = color.split('.');
      return theme.palette[colorPath[0]][colorPath[1]];
    }
    return color;
  };

  return (
    <Box
      sx={{
        position: 'relative',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}
    >
      <svg
        width={size}
        height={size}
        viewBox={`0 0 ${size} ${size}`}
        style={{ transform: 'rotate(-90deg)' }}
      >
        {/* Background Circle */}
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          stroke={backgroundColor}
          strokeWidth={strokeWidth}
          fill="none"
        />
        
        {/* Progress Circle */}
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          stroke={getColor(progressColor)}
          strokeWidth={strokeWidth}
          fill="none"
          strokeDasharray={circumference}
          strokeDashoffset={circumference - progress}
          strokeLinecap="round"
          style={{
            transition: 'stroke-dashoffset 0.5s ease-in-out'
          }}
        />
      </svg>
      
      {/* Percentage Text in the Center */}
      {showPercentage && (
        <Typography
          variant="caption"
          component="div"
          sx={{
            position: 'absolute',
            fontSize: fontSize,
            fontWeight: 'bold',
            color: textColor,
            userSelect: 'none'
          }}
        >
          {`${score}%`}
        </Typography>
      )}
    </Box>
  );
};

